import { ENDPOINTS } from '../../apis/endpoints';
import { apiSlice } from '../../app/api/apiSlice';

export const commentApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getComments: builder.query({
      query: (empCode) => `${ENDPOINTS.COMMENT.BASE}${empCode}`,
      providesTags: (result, error, _id) =>
        result
          ? [{ type: 'Comment', id: 'LIST' }, ...result.map(({ _id }) => ({ type: 'Comment', id: _id }))]
          : [{ type: 'Comment', id: 'LIST' }],
    }),
    addComment: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.COMMENT.BASE}`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: 'Comment', id: 'LIST' }],
    }),
    editComment: builder.mutation({
      query: ({ id, data }) => ({
        url: `${ENDPOINTS.COMMENT.BASE}${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Comment', id }],
    }),
    deleteComment: builder.mutation({
      query: (id) => ({
        url: `${ENDPOINTS.COMMENT.BASE}${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [{ type: 'Comment', id }],
    }),
  }),
});

export const { useGetCommentsQuery, useAddCommentMutation, useEditCommentMutation, useDeleteCommentMutation } =
  commentApiSlice;
